const integer = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 0, minimumFractionDigits: 0 });
const oneDigit = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 1, minimumFractionDigits: 1 });
const twoDigits = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 2, minimumFractionDigits: 2 });

/** Рубли без копеек: «1 008 190» */
export const rub = (value: number) => integer.format(Math.round(value));

/** Рубли со знаком валюты */
/** Рубли со знаком валюты; неразрывный пробел — «₽» не уезжает на новую строку */
export const rubSign = (value: number) => `${rub(value)}\u00a0₽`;

/** Крупные суммы для карточек: «41,5 млн ₽» */
export const rubCompact = (value: number) => {
    const abs = Math.abs(value);
    if (abs >= 1_000_000) {
        return `${oneDigit.format(value / 1_000_000)} млн ₽`;
    }

    if (abs >= 10_000) {
        return `${integer.format(value / 1_000)} тыс ₽`;
    }

    return rubSign(value);
};

export const percent = (value: number | null, digits = 0) =>
    value === null ? "—" : `${digits ? oneDigit.format(value) : integer.format(value)}%`;

/** Отклонение со знаком: «+18,3%» */
export const signedPercent = (value: number | null) =>
    value === null ? "—" : `${value > 0 ? "+" : value < 0 ? "−" : ""}${oneDigit.format(Math.abs(value))}%`;

export const hours = (value: number) => `${integer.format(value)} ч`;

export const ratio = (value: number) => twoDigits.format(value);
